export { BooleanTransform as default } from '@ember-data/serializer/transform';
